import "./Translations.html";
import "./Translations.scss";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import TranslationsComponentController from "./TranslationsComponentController";

export class TranslationsComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {};
        this.controller = TranslationsComponentController;
        this.templateUrl = "/App/Components/Translations/Translations.html";
    }
}

module("mmManagePortal").component("mmTranslations", new TranslationsComponent());
